import { render, staticRenderFns } from "./ColorCount.vue?vue&type=template&id=5da9a32d&scoped=true&"
import script from "./ColorCount.vue?vue&type=script&lang=js&"
export * from "./ColorCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9a32d",
  null
  
)

export default component.exports